// 'use client';

// import React from 'react';

// const WhyIranija: React.FC = () => {
//   const features = [

//     {
//       id: 1,
//       title: 'رزرو آسان',
//       desc: 'کاملا رایگان همراه با امتیاز',
//       icon: '/icons/png/calendar.png', 
//       // theme: 'light', // تم زرد
//     },
//     {
//       id: 2,
//       title: 'گارانتی بهترین قیمت',
//       desc: 'همیشه کمترین نرخ موجود را به شما ارائه می‌کنیم.',
//       icon: '/icons/png/coins.png', 
//       // theme: 'dark', // تم سرمه‌ای
//     },
//     {
//       id: 3,
//       title: 'پشتیبانی تخصصی',
//       desc: 'کارشناسان سفر همیشه آماده راهنمایی شما هستند.',
//       icon: '/icons/png/headset.png', 
//       // theme: 'light',
//     },
//     {
//       id: 4,
//       title: 'پوشش سراسری',
//       desc: 'دسترسی به بیش از ۱۰۰۰ هتل و اقامتگاه های مختلف.',
//       icon: '/icons/png/global.png',
//       // theme: 'light',
//     }
  
//   ];

//   return (
//     <section className="section-wrapper">
//       <div className="container">
        
//         {/* --- هدر --- */}
//         <div className="header-content">
//           <h2 className="title">چرا ایرانیجا؟</h2>
//           <div className="desc-box">
//              <p className="description">
//             یکی از معتبرترین پلتفرم خرید اینترنتی بلیط هواپیما، قطار و اتوبوس در کشور، از سال ۱۳۹۳ فعالیت خود را با هدف تسهیل خرید آنلاین خدمات سفر آغاز کرده و در این مدت توانسته است اعتماد و رضایت درصد بالایی از کاربران را جلب کند.
//             </p>
//           </div>
//         </div>

//         {/* --- لیست آیتم‌ها --- */}
//         <div className="items-row">
//           {features.map((item) => (
//             <div key={item.id} className="item-card">
              
//               {/* ناحیه گرافیکی با تنظیمات دقیق */}
//               <div className="icon-area">
           
//                  {/* تصویر */}
//                  <div className="img-wrapper">
//                     <img 
//                       src={item.icon} 
//                       alt={item.title} 
//                       className="feature-img"
//                     />
//                  </div>
//               </div>

//               <h3 className="item-title">{item.title}</h3>
//               <p className="item-desc">{item.desc}</p>
//             </div>
//           ))}
//         </div>

//       </div>

//       <style jsx>{`
//         /* --- کانتینر اصلی --- */
//         .section-wrapper {
//           width: 100%;
//           background-color: #f3f4f6;
//           padding: 70px 20px;
//           direction: rtl;
//           font-family: 'Vazir', 'Tahoma', sans-serif;
//           display: flex;
//           justify-content: center;
//           position: relative;
//           z-index: 1;
//         }

//         .container {
//           width: 100%;
//           max-width: 1140px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//         }

//         /* --- هدر --- */
//         .header-content {
//           margin-bottom: 60px;
//           text-align: center;
//           width: 100%;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//         }

//         .title {
//           font-size: 26px;
//           font-weight: 800;
//           color: #374151; /* gray-700 */
//           margin: 0 0 25px 0;
//         }

//         .desc-box {
//           max-width: 800px;
//         }

//         .description {
//           font-size: 14px;
//           line-height: 2.3;
//           color: #6b7280; /* gray-500 */
//           font-weight: 500;
//           margin: 0;
//           text-align: center;
//         }

//         /* --- ردیف آیتم‌ها --- */
//         .items-row {
//           display: flex;
//           width: 100%;
//           justify-content: space-between;
//           flex-wrap: wrap;
//         }

//         .item-card {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           text-align: center;
//           width: 25%; /* دسکتاپ: 4 ستون */
//           position: relative;
//           padding: 0 10px;
//         }

//         /* --- گرافیک (اصلاح شده) --- */
//         .icon-area {
//             position: relative;
//             width: 140px; /* عرض ناحیه گرافیک */
//             height: 120px; /* ارتفاع ناحیه گرافیک */
//             display: flex;
//             justify-content: center;
//             align-items: flex-end; /* چسبیدن المان‌ها به پایین */
//             margin-bottom: 20px;
//         }

//         /* سکوی بیضی شکل (پهن و تخت) */
//         .platform {
//             position: absolute;
//             bottom: 15px; /* فاصله از کف */
//             width: 90px;
//             height: 22px; /* ارتفاع کم برای تخت شدن */
//             border-radius: 50px; /* کاملا گرد */
//             z-index: 1;
//         }
//         .pf-light { background-color: #fbbf24; } /* زرد */
//         .pf-dark { background-color: #1e3a8a; } /* سرمه‌ای */

//         /* خط تیره */
//         .dash {
//             position: absolute;
//             bottom: 5px; /* پایین‌تر از سکو */
//             width: 35px;
//             height: 6px;
//             border-radius: 10px;
//             z-index: 2;
//         }
//         /* ترفند وسط چین کردن ابسولوت */
//         .dash-navy { 
//             background-color: #1e3a8a; 
//             left: 50%;
//             transform: translateX(-50%);
//         }
//         .dash-teal { 
//             background-color: #2dd4bf; /* رنگ فیروزه‌ای روشن */
//             left: 50%;
//             transform: translateX(-50%);
//         }

//         /* نگهدارنده عکس برای کنترل دقیق */
//         .img-wrapper {
//             position: relative;
//             z-index: 10; /* بالاترین لایه */
//             width: 100%;
//             height: 100%;
//             display: flex;
//             justify-content: center;
//             align-items: flex-end;
//             padding-bottom: 18px; /* عکس روی سکو بنشیند */
//         }

//         .feature-img {
//             width: auto;
//             height: 90px; /* سایز بزرگ عکس */
//             object-fit: contain;
//             /* سایه نرم زیر عکس برای جدا شدن از پس زمینه */
//             filter: drop-shadow(0 10px 10px rgba(0,0,0,0.1));
//             transition: transform 0.3s ease;
//         }

//         /* افکت هاور دلخواه (اختیاری) */
//         .item-card:hover .feature-img {
//             transform: translateY(-5px);
//         }

//         .item-title {
//             font-size: 16px;
//             font-weight: 800;
//             color: #1f2937;
//             margin-bottom: 10px;
//         }

//         .item-desc {
//             font-size: 13px;
//             color: #6b7280;
//             line-height: 1.8;
//             max-width: 200px;
//             text-align:center;
//         }

//         /* --- تنظیمات موبایل (دقیق طبق عکس) --- */
//         @media (max-width: 768px) {
//             .section-wrapper {
//                 padding: 40px 15px;
//             }

//             .title {
//                 font-size: 22px;
//                 margin-bottom: 15px;
//             }

//             .description {
//                 font-size: 12px;
//                 line-height: 2.2;
//                 text-align: justify;
//                 text-align-last: center;
//                 -moz-text-align-last: center; 
//             }
            
//             .desc-box {
//                 padding: 0 10px;
//             }

//             /* فاصله عمودی سطرها */
//             .items-row {
//                 row-gap: 40px; 
//                 justify-content: center;
//             }

//             .item-card {
//                 width: 50%; /* دو ستون */
//                 margin-bottom: 10px;
//                 padding: 0 5px;
//             }
            
//             .icon-area {
//                 width: 100%;
//                 height: 100px;
//                 margin-bottom: 10px;
//             }
            
//             .feature-img {
//                 height: 75px; /* کمی کوچکتر در موبایل */
//             }

//             .platform {
//                 width: 70px;
//                 height: 18px;
//                 bottom: 12px;
//             }

//             .dash {
//                 width: 25px;
//                 height: 5px;
//                 bottom: 4px;
//             }
            
//             .img-wrapper {
//                  padding-bottom: 15px;
//             }

//             .item-title {
//                 font-size: 14px;
//                 margin-bottom: 5px;
//             }

//             .item-desc {
//                 font-size: 11px;
//                 line-height: 1.6;
//                 width: 100%;
//                 max-width: 140px;
//             }
//         }
//       `}</style>
//     </section>
//   );
// };

// export default WhyIranija;


'use client';

import React from 'react';
import SeoHeading from '../seo/SeoHeading';
import { HomeSeoSlots, getHomeSlot } from '../../../src/lib/seo/home-headings';

type Props = {
  headings: HomeSeoSlots;
};

const WhyIranija: React.FC<Props> = ({ headings }) => {
  const sectionTitle = getHomeSlot(headings, 'whyIranijaTitle');

  const features = [
    {
      id: 1,
      titleSlot: 'whyFeature1Title',
      desc: 'کاملا رایگان همراه با امتیاز',
      icon: '/icons/png/calendar.png',
    },
    {
      id: 2,
      titleSlot: 'whyFeature2Title',
      desc: 'همیشه کمترین نرخ موجود را به شما ارائه می‌کنیم.',
      icon: '/icons/png/coins.png',
    },
    {
      id: 3,
      titleSlot: 'whyFeature3Title',
      desc: 'کارشناسان سفر همیشه آماده راهنمایی شما هستند.',
      icon: '/icons/png/headset.png',
    },
    {
      id: 4,
      titleSlot: 'whyFeature4Title',
      desc: 'دسترسی به بیش از ۱۰۰۰ هتل و اقامتگاه های مختلف.',
      icon: '/icons/png/global.png',
    },
  ];

  return (
    <section className="section-wrapper">
      <div className="container">
        <div className="header-content">
          <SeoHeading slot={sectionTitle} className="why-iranija-title" />
          <div className="desc-box">
            <p className="description">
              یکی از معتبرترین پلتفرم خرید اینترنتی بلیط هواپیما، قطار و اتوبوس در کشور، از سال ۱۳۹۳ فعالیت خود را با هدف تسهیل خرید آنلاین خدمات سفر آغاز کرده و در این مدت توانسته است اعتماد و رضایت درصد بالایی از کاربران را جلب کند.
            </p>
          </div>
        </div>

        <div className="items-row">
          {features.map((item) => {
            const featureHeading = getHomeSlot(headings, item.titleSlot);

            return (
              <div key={item.id} className="item-card">
                <div className="icon-area">
                  <div className="img-wrapper">
                    <img
                      src={item.icon}
                      alt={featureHeading.text}
                      className="feature-img"
                    />
                  </div>
                </div>

                <SeoHeading slot={featureHeading} className="why-feature-title" />
                <p className="item-desc">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>

      <style jsx>{`
        .section-wrapper {
          width: 100%;
          background-color: #f3f4f6;
          padding: 70px 20px;
          direction: rtl;
          font-family: 'Vazir', 'Tahoma', sans-serif;
          display: flex;
          justify-content: center;
          position: relative;
          z-index: 1;
        }

        .container {
          width: 100%;
          max-width: 1140px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .header-content {
          margin-bottom: 60px;
          text-align: center;
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        :global(.why-iranija-title) {
          font-size: 26px;
          font-weight: 800;
          color: #374151;
          margin: 0 0 25px 0;
          display: block;
        }

        .desc-box {
          max-width: 800px;
        }

        .description {
          font-size: 14px;
          line-height: 2.3;
          color: #6b7280;
          font-weight: 500;
          margin: 0;
          text-align: center;
        }

        .items-row {
          display: flex;
          width: 100%;
          justify-content: space-between;
          flex-wrap: wrap;
        }

        .item-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          width: 25%;
          position: relative;
          padding: 0 10px;
        }

        .icon-area {
          position: relative;
          width: 140px;
          height: 120px;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          margin-bottom: 20px;
        }

        .img-wrapper {
          position: relative;
          z-index: 10;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          padding-bottom: 18px;
        }

        .feature-img {
          width: auto;
          height: 90px;
          object-fit: contain;
          filter: drop-shadow(0 10px 10px rgba(0,0,0,0.1));
          transition: transform 0.3s ease;
        }

        .item-card:hover .feature-img {
          transform: translateY(-5px);
        }

        :global(.why-feature-title) {
          font-size: 16px;
          font-weight: 800;
          color: #1f2937;
          margin: 0 0 10px 0;
          display: block;
        }

        .item-desc {
          font-size: 13px;
          color: #6b7280;
          line-height: 1.8;
          max-width: 200px;
          text-align: center;
        }

        @media (max-width: 768px) {
          .section-wrapper {
            padding: 40px 15px;
          }

          :global(.why-iranija-title) {
            font-size: 22px;
            margin-bottom: 15px;
          }

          .description {
            font-size: 12px;
            line-height: 2.2;
            text-align: justify;
            text-align-last: center;
            -moz-text-align-last: center;
          }

          .desc-box {
            padding: 0 10px;
          }

          .items-row {
            row-gap: 40px;
            justify-content: center;
          }

          .item-card {
            width: 50%;
            margin-bottom: 10px;
            padding: 0 5px;
          }

          .icon-area {
            width: 100%;
            height: 100px;
            margin-bottom: 10px;
          }

          .feature-img {
            height: 75px;
          }

          .img-wrapper {
            padding-bottom: 15px;
          }

          :global(.why-feature-title) {
            font-size: 14px;
            margin-bottom: 5px;
            text-align: center;
          }

          .item-desc {
            font-size: 11px;
            line-height: 1.6;
            width: 100%;
            max-width: 140px;
          }
        }
      `}</style>
    </section>
  );
};

export default WhyIranija;